<kodit-field fieldLabel="Esir datum i vreme">
  <kodit-calendar
    class="p-fluid"
    formCtrlId="startDate"
    [formCtrl]="fiskalniRacunForm.controls.dateAndTimeOfIssue"
    [showTime]="true"
    [showSeconds]="true"
  ></kodit-calendar>
</kodit-field>
